import React, {useEffect, useRef} from 'react';
import {
  Text,
  StyleSheet,
  Animated,
  View,
  Dimensions,
  Platform,
} from 'react-native';
import Styles from 'src/components/Styles';
import {getToastDescriber} from 'src/components/elements/toastDescriptor/DescroiptorType';
import TickIcon from 'src/components/img/svg/TickIcon';
import Localized from 'src/constants/AppStrings';

export enum CartItemType {
  Reward = 'Reward',
  Menu = 'Menu',
  RecentOrder = 'RecentOrder',
}

type CartToastViewProps = {
  cartItemType: CartItemType;
  showMessage: boolean;
};

const CartToastView = (props: CartToastViewProps) => {
  const fadeAnim = useRef(new Animated.Value(1)).current;
  const duration = 5000;
  const {cartToastViewStyle, cartToastTextStyle, snackBarFontFamily} =
    getToastDescriber();

  useEffect(() => {
    if (props.showMessage) {
      Animated.timing(fadeAnim, {
        toValue: 0,
        duration: duration,
        useNativeDriver: true,
      }).start();
    }
  }, [fadeAnim]);

  useEffect(() => {
    if (props.showMessage) {
      const timeout = setTimeout(() => {
        Animated.timing(fadeAnim, {
          toValue: 1,
          duration: duration,
          useNativeDriver: true,
        }).start();
      }, duration);

      return () => clearTimeout(timeout);
    }
  }, [duration]);

  const toastMessage = () => {
    switch (props.cartItemType) {
      case CartItemType.Menu:
      case CartItemType.RecentOrder:
        return Localized.Labels.successfully_added_to_cart;
      case CartItemType.Reward:
        return Localized.Labels.successfully_added_reward_to_cart;
    }
  };

  return props.showMessage ? (
    <Animated.View
      style={{
        opacity: fadeAnim,
        duration: 2000,
      }}
    >
      <View style={styles.containerView}>
        <View style={[styles.messageView, cartToastViewStyle()]}>
          <View style={styles.logoView}>
            <TickIcon color={cartToastTextStyle().color} />
          </View>
          <Text
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            style={[
              styles.messageText,
              cartToastTextStyle(),
              {fontFamily: snackBarFontFamily()},
            ]}
          >
            {toastMessage()}
          </Text>
        </View>
      </View>
    </Animated.View>
  ) : null;
};

const styles = StyleSheet.create({
  messageText: {
    fontSize: Styles.Fonts.f1,
    textAlign: 'center',
    fontWeight: '700',
  },
  messageView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    borderRadius: 4,
    borderWidth: 2,
    opacity: 9999999,
    paddingRight: 28,
    paddingLeft: 6,
    paddingVertical: 6,
  },
  containerView: {
    alignSelf: 'center',
    backgroundColor: Styles.white,
    bottom: 110,
    zIndex: 999,
    position: 'absolute',
    borderRadius: 4,
    ...Platform.select({
      web: {
        bottom: 40,
        marginLeft: Dimensions.get('window').width / 3,
      },
    }),
  },
  logoView: {
    paddingVertical: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m2,
  },
});

export default CartToastView;
